import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { TServicesByCustomerType } from '../../types/services';

export type IState = {
  list: TServicesByCustomerType;
};

const servicesSlice = createSlice({
  name: 'services',
  initialState: {
    list: null,
  },
  reducers: {
    setServices: (state, { payload }: PayloadAction<TServicesByCustomerType>) => {
      state.list = payload;
    },
  },
});

const { reducer, actions } = servicesSlice;

export const { setServices } = actions;

export default reducer;
